import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

const LoadingOverlay = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
      backgroundColor: 'white',
      marginTop: '100px'
    }}
  >
    <CircularProgress />
  </Box>
);

export default LoadingOverlay;
